import moment from 'moment'

const PERIODS = {
  monthly: 1,
  quarterly: 3,
  yearly: 12,
}

export const PERIODS_LABELS = {
  monthly: 'monthly',
  quarterly: 'quarterly',
  yearly: 'yearly',
  other: 'other',
}

export const getDatePeriod = (startDate: moment.Moment, endDate: moment.Moment) => {
  const start = moment(startDate)
  const end = moment(endDate)

  const diffInMonths = end.diff(start, 'months') + 1
  const diffInYears = end.diff(start, 'years')

  if (diffInMonths === PERIODS.monthly) {
    return PERIODS_LABELS.monthly
  } else if (diffInMonths === PERIODS.quarterly) {
    return PERIODS_LABELS.quarterly
  } else if (diffInMonths === PERIODS.yearly || diffInYears === 1) {
    return PERIODS_LABELS.yearly
  } else {
    return PERIODS_LABELS.other
  }
}

export const parseFormattedDateLabel = (label: string): string => {
  return label.replace(/[^a-zA-Z0-9\s]/g, '')
}
